"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({ showSpinner: false, trickleSpeed: 200, minimum: 0.9 });

// App Router has no router.events, so we approximate "navigation finished" by
// reacting to pathname/searchParams changes. Starting the bar requires a global
// hook into link clicks — for the pilot we just complete on settle.
export default function RouteProgressApp() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    NProgress.done();
  }, [pathname, searchParams]);

  return null;
}
